import { createKeyedStateSelector } from '../../shared/utils/selectorUtils';
import { getCreativeLayerByElementId } from '../../creative/state-management/selectors';
import { TEXT_FILL } from '../constants';

import { TextProperties } from 'content-creation-common/preview/text';
import clientCanvasTextMeasurer from '../util/measurement';

export const getAdjustedFontSize = (creativeLayer) => {
  const textProperties = new TextProperties(creativeLayer);
  const {
    fillProperties: { mode: fillMode },
  } = textProperties;

  let adjustedTextProperties = textProperties;

  if (fillMode !== TEXT_FILL.ABSOLUTE) {
    adjustedTextProperties = clientCanvasTextMeasurer.getTextRenderProperties(
      textProperties,
    );
  }

  return adjustedTextProperties.fontSize;
};

export const getAdjustedFontSizeByElementId = createKeyedStateSelector(
  [getCreativeLayerByElementId],
  (creativeLayer) => getAdjustedFontSize(creativeLayer),
);

// Returns a TextRenderProperties object
export const getCanvasTextMeasurements = (creativeLayer) => {
  const textProperties = new TextProperties(creativeLayer);
  return clientCanvasTextMeasurer.getTextRenderProperties(textProperties);
};
